import { render, staticRenderFns } from "./mChatQrcode.vue?vue&type=template&id=17ca4f3b"
import script from "./mChatQrcode.vue?vue&type=script&lang=js"
export * from "./mChatQrcode.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\web\\medical\\medical-autism\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('17ca4f3b')) {
      api.createRecord('17ca4f3b', component.options)
    } else {
      api.reload('17ca4f3b', component.options)
    }
    module.hot.accept("./mChatQrcode.vue?vue&type=template&id=17ca4f3b", function () {
      api.rerender('17ca4f3b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/autism/mChat/mChatQrcode/mChatQrcode.vue"
export default component.exports